import { cx } from '@emotion/css';
import { ReactNode } from 'react';

import {
  bodyClassName,
  bodySpacingClassName,
  headerClassName,
  headingClassName,
  sectionClassName,
  spacingClassName,
  subheadingClassName,
} from './styles';

interface Props {
  children: ReactNode;
  className?: string;
  description?: string;
  spacing?: boolean;
  title?: string;
}

const Section = ({
  children,
  className = '',
  description,
  spacing,
  title,
}: Props) => {
  const showHeader = !!title || !!description;
  return (
    <div
      className={cx(sectionClassName, {
        [spacingClassName]: spacing,
        [className]: !!className,
      })}
    >
      {showHeader && (
        <div className={headerClassName}>
          {title && <h2 className={headingClassName}>{title}</h2>}
          {description && (
            <h4 className={subheadingClassName}>{description}</h4>
          )}
        </div>
      )}
      <div
        className={cx(bodyClassName, { [bodySpacingClassName]: showHeader })}
      >
        {children}
      </div>
    </div>
  );
};

Section.displayName = 'Section';

export default Section;
